import { useQuery } from '@tanstack/react-query';
import { $apiFetchClient } from 'src/services/api';

export interface FbaSettings {
  enabled: boolean;
}

// Company-Schalter res.company.fba_label_enabled (Backend-Freigabe, analog zu
// cod_settings). Endpoint ist noch nicht in den generierten Typen — daher
// untyped GET mit lokalem Interface (Übergangsmuster, s. codSettings.ts).
export const useFbaSettingsQuery = () =>
  useQuery({
    queryKey: ['get', '/sale_orders/fba_settings/'],
    queryFn: async () => {
      const response = await ($apiFetchClient as { GET: Function }).GET('/sale_orders/fba_settings/', {});
      if (response.error) throw response.error;
      return (response.data ?? { enabled: false }) as FbaSettings;
    },
    staleTime: 5 * 60 * 1000,
  });
